import { Colors, Fonts } from '../../../shared/theme/';
import React from 'react';
import metrics from '../../../shared/theme/metrics';
import styleText from '../../../shared/components/rbh-text/styles';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '16px',
    height: '56px'
  } as React.CSSProperties,
  emptyWrapper: {
    textAlign: 'center',
    marginTop: metrics.base * 10
  },
  subTitleText: {
    ...styleText.textRegular14,
    color: Colors.font.primary.darkGray,
    marginBottom: metrics.base * 2
  },
  emptyText: {
    paddingTop: metrics.baseMargin,
    ...styleText.text16fakeBlack,
    fontFamily: Fonts.type.Kanit
  },
  logoutText: {
    ...styleText.text12,
    textDecoration: 'underline',
    color: Colors.lightPurple,
    cursor: 'pointer'
  }
};
